// extracted by mini-css-extract-plugin
export var notificationHost = "_el-0";